import { useQuery } from "@tanstack/react-query"

import type { WorkflowResponse } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function getWorkflows(): Promise<WorkflowResponse> {
  return api.get("/explorer/workflows")
}

export function useGetWorkflows() {
  const workflowsQuery = useQuery({
    queryKey: queryKeys.workflows,
    queryFn: () => getWorkflows(),
    enabled: true,
  })

  return workflowsQuery
}
